<div class="offer">
    <div class="offer-banner" ng-click="vm.go()" ng-class="{
            'offer-banner_white': vm.backgroundColor === 'alb',
            'offer-banner_blue': vm.backgroundColor === 'albastru',
            'offer-banner_yellow': vm.backgroundColor === 'galben',
            'offer-banner_purple': vm.backgroundColor === 'mov',
            'offer-banner_black': vm.backgroundColor === 'negru',
            'offer-banner_pink': vm.backgroundColor === 'roz',
            'offer-banner_green': vm.backgroundColor === 'verde',
            'offer-banner_clickable': vm.link
        }"
    >
        <div class="container">
            <div class="row offer-banner__row">
                <div class="col-xs-12 center">
                    <img ng-src="{{vm.bannerLink}}" class="img-responsive">
                </div>
            </div>
        </div>
    </div>
    <p class="offer-terms center" ng-if="vm.termsAndConditionsLink">
        Vezi regulamentul <a target="_blank" ng-href="{{vm.termsAndConditionsLink}}">aici</a>
    </p>
</div>
